import React, { useContext, useEffect, useState } from 'react';

interface LayoutContextModel {
  width: number;
  height: number;
}

const LayoutContext = React.createContext<LayoutContextModel>(null);

export const LayoutConsumer = LayoutContext.Consumer;

export const useLayoutContext = () => {
  return useContext(LayoutContext);
};

export const LayoutProvider: React.FC<{children: any}> = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  const value = {
    width,
    height,
  };
  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
